import React, {useEffect, useState} from "react"
import {NavLink} from "react-router-dom"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faBars, faChevronDown, faTimes} from "@fortawesome/free-solid-svg-icons"

import styles from "./MobileNav.module.scss"

export default function MobileNav({pages}) {
    const [isOpen, setIsOpen] = useState(false)
    const [expandedIndex, setExpandedIndex] = useState(null)

    useEffect(() => {
        if (!isOpen) return

        const handleKeyDown = (event) => {
            if (event.key === 'Escape') closeMenu()
        }
        document.addEventListener('keydown', handleKeyDown)
        document.body.style.overflow = 'hidden'

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
            document.body.style.overflow = ''
        }
    }, [isOpen])

    function toggleMenu() {
        setIsOpen((prev) => !prev)
        setExpandedIndex(null)
    }

    function closeMenu() {
        setIsOpen(false)
        setExpandedIndex(null)
    }

    function toggleSection(index) {
        setExpandedIndex((prev) => (prev === index ? null : index))
    }

    return (
        <div className={styles.mobileNav}>
            <FontAwesomeIcon
                icon={isOpen ? faTimes : faBars}
                onClick={toggleMenu}
                title="Menu"
                className={styles.burger}
            />
            {isOpen && (
                <>
                    <div className={styles.backdrop} onClick={closeMenu}/>
                    <ul className={styles.panel}>
                        {pages.map((page, index) => (
                            page.children?.length ? (
                                <li key={index} className={styles.section}>
                                    <div className={styles.sectionHeader} role="button" tabIndex={0}
                                         onClick={() => toggleSection(index)}
                                         onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && toggleSection(index)}>
                                        {page.title}
                                        <FontAwesomeIcon icon={faChevronDown}
                                                          className={`${styles.chevron} ${expandedIndex === index ? styles.chevronOpen : ''}`}/>
                                    </div>
                                    {expandedIndex === index && (
                                        <ul className={styles.sectionList}>
                                            {page.children.map((child, childIndex) => (
                                                <li key={childIndex}>
                                                    <NavLink to={child.to} onClick={closeMenu}
                                                             className={({isActive}) => isActive ? styles.active : undefined}>
                                                        {child.title}
                                                    </NavLink>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </li>
                            ) : (
                                <li key={index}>
                                    <NavLink to={page.to} onClick={closeMenu}
                                             className={({isActive}) => isActive ? styles.active : undefined}>
                                        {page.title}
                                    </NavLink>
                                </li>
                            )
                        ))}
                    </ul>
                </>
            )}
        </div>
    )
}
